export default "__VITE_ASSET__BvcMlAO6__"